import { useState } from 'react'

import { Location, PractitionerScheduleLocation } from '~/storm'

import { DatePractitionerCell } from '../../../shared'
import { LocationTag } from './LocationTag'

type Props = {
    selectedCells: DatePractitionerCell[]
    availableLocations: Location[]
    scheduleLocations: PractitionerScheduleLocation[]
}

export const LocationTagsWithStaticState = ({ selectedCells, availableLocations, scheduleLocations }: Props) => {
    const [initialLocationsState] = useState(() => availableLocations)

    return (
        <>
            {initialLocationsState.map(location => (
                <LocationTag key={location.uuid} selectedCells={selectedCells} scheduleLocations={scheduleLocations} location={location} />
            ))}
        </>
    )
}
